export enum ExportTypeCodes {
    XML = "X",
    CSV = "C",
    EXCEL = "E",
    ZIP = "Z"
}
    